/* istanbul ignore file */

import { defaultState } from '../reducer.defaultState';

import { ListingsBenchmarkAuthStatusActionTypes } from './constants';

export const authStatus = (state, action) => {
  switch (action.type) {
    case ListingsBenchmarkAuthStatusActionTypes.RESET_LISTINGS_BENCHMARK_STATE:
      return {
        ...defaultState(),
        previouslySelectedDate: state.previouslySelectedDate,
        previouslySelectedTimeDivision: state.previouslySelectedTimeDivision,
      };
    case ListingsBenchmarkAuthStatusActionTypes.FULL_RESET_LISTINGS_BENCHMARK_STATE:
      return {
        ...defaultState(),
      };
    case ListingsBenchmarkAuthStatusActionTypes.SAVE_PREVIOUSLY_SELECTED_DATE:
      return {
        ...state,
        previouslySelectedDate: action.selectedDate,
        previouslySelectedTimeDivision: action.timeDivision,
      };
    default:
      return state;
  }
};
